// extracted by mini-css-extract-plugin
export default {"AppStyle":"app_AppStyle__L5HW2"};